// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9v-3";
export var contentContainer = "_9v-0";
export var editorContainer = "_9v-1";
export var quillInputForm = "_9v-2";
export var zoneDivider = "_9v-4";